<template>
  <v-snackbar
    v-model="show"
    v-bind:color="type"
    timeout="5000"
    bottom
    right
  >
    {{ text }}

    <template v-slot:action="{ attrs }">
      <v-btn
        dark
        text
        v-bind="attrs"
        v-on:click="show = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Message',
  computed: {
    show: {
      get () {
        return this.$store.getters.showMessage
      },
      set (value) {
        this.$store.dispatch('updateMessageShow')
      }
    },
    ...mapState({
      text: state => state.message.text,
      type: state => state.message.type,
    })
  },
}
</script>
